import React, { useState, useEffect } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useInsights } from 'contexts/insights'
import { usePossum } from 'hooks/possum'
import { getPeopleProfileUrl } from 'utilities/url'
import { getShortName } from 'utilities/person'
import Loader, { LoaderWrap } from 'components/loader'
import Modal from 'modals/dialog'
import {
    User as Profile,
    UserPlus as Include
} from 'styled-icons/feather'
import { Users } from './s'
import User from './user'
import Paragraph from 'components/typography/paragraph'

const salt = 'insights:excluded-users'

const ExcludedUsers = () => {
    const { formatMessage } = useIntl()
    const possessify = usePossum()

    const {
        excludedUsers,
        hasFetchedExcludedUsers,

        fetchExcludedUsers,
        includeUser
    } = useInsights()

    const [includingUserId, setIncludingUserId] = useState(null)

    useEffect(() => {
        fetchExcludedUsers()
    }, [])

    if(!hasFetchedExcludedUsers) {
        return (
            <LoaderWrap $height={120}>
                <Loader />
            </LoaderWrap>
        )
    }

    const actions = {
        navigateProfile: user => ({
            salt: `${salt}:navigate-to-profile`,
            icon: <Profile size={24} />,
            label: formatMessage({
                id: 'action_navigate_user',
                defaultMessage: 'Go to {pname} profile'
            }, { pname: possessify(getShortName(user)) }),
            effect: 'neutral',
            element: 'link',
            link: {
                to: getPeopleProfileUrl(user),
                target: '_blank'
            }
        }),
        includeUser: ({ id }) => ({
            salt: `${salt}:include-user`,
            icon: <Include size={24} />,
            label: formatMessage({
                id: 'person_action_include_in_insights',
                defaultMessage: 'Include in insights'
            }),
            effect: 'neutral',
            element: 'button',
            onClick: async () => {
                setIncludingUserId(id)
                await includeUser(id)
                setIncludingUserId(null)
            }
        })
    }

    return (
        <>
            <Modal.Header heading={formatMessage({
                id: 'excluded_users_heading',
                defaultMessage: 'Excluded users'
            })} />
            <Modal.Body>
                <Users>
                    {excludedUsers.map(user => {
                        const key = `${salt}:user:${user.id}`

                        return (
                            <User
                                user={user}
                                actions={actions}
                                pending={includingUserId === user.id}
                                salt={key}
                                key={key} />
                        )
                    })}
                </Users>
                {!excludedUsers.length && (
                    <Paragraph>
                        <FormattedMessage
                            id="excluded_users_empty_none_manageable"
                            defaultMessage="There are no excluded users that you can manage." />
                    </Paragraph>
                )}
            </Modal.Body>
        </>
    )
}

export default ExcludedUsers